/***
 * 本地存储数据模型
 * {id1:{key1:value1},id2:{key2:value2},}
 * 皮肤数据：config:{skinId:green}
 * @param id
 * @param key
 * @param value
 */

export function saveToLocal(id, key, value) {
    let globalData = window.localStorage.__global__;
    if (!globalData) {
        globalData = {};
        globalData[id] = {};
    } else {
        globalData = JSON.parse(globalData);
        if (!globalData[id]) {
            globalData[id] = {};
        }
    }
    globalData[id][key] = value;
    window.localStorage.__global__ = JSON.stringify(globalData);
};

export function loadFromLocal(id, key, def) {
    let globalData = window.localStorage.__global__;
    if (!globalData) {
        return def;
    }
    globalData = JSON.parse(globalData)[id];
    if (!globalData) {
        return def;
    }
    let ret = globalData[key];
    return ret || def;
};


// WEBPACK FOOTER //
// ./src/common/js/store.js